import { render, staticRenderFns } from "./wallet.success.vue?vue&type=template&id=890a4dd6&scoped=true&"
import script from "./wallet.success.vue?vue&type=script&lang=js&"
export * from "./wallet.success.vue?vue&type=script&lang=js&"
import style0 from "./wallet.success.vue?vue&type=style&index=0&id=890a4dd6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890a4dd6",
  null
  
)

component.options.__file = "wallet.success.vue"
export default component.exports